import Project from "./Project";
import sc1 from '../assets/sc1.png';
import sc2 from '../assets/sc2.png';
import sc3 from '../assets/sc3.png';
import sc4 from '../assets/sc4.png';
import sc5 from '../assets/sc5.png';
import sc6 from '../assets/api key mangment.png';
import sc7 from '../assets/app.png';
import sc8 from '../assets/checkout.png';
const Projects = props => {
    return (
      <section id="projects">
        <div className="projects-container">
          <div className="heading">
            <h3 className="title">My Works</h3>
            <p className="separator" />
            <p className="subtitle">
            Here are a few  projects I have worked on recently. Want to see more?<a href="https://emanuelawol1960@gmail.com"> Email me</a>{' '}
        
            </p>
          </div>
          <div className="projects-wrapper">
          <div className="">
         
          <Project
              title="TECH-TURE."
              img={sc1}
              tech="js css react"
              link="https://techture-1ee36.firebaseapp.com/"
              repo="/"
            >
              <small>
                Built using firebase, CSS , React.js and React Router.
              </small>
              <p>
                This is a full-stack website that I made which lets the users find a new movies to watch. and save his favorites.
              </p>
            </Project>
            <Project
              title="App"
              img={sc7}
              tech="Flutter dart sql AWS socket.io"
              link=""
              repo="/"
            >
              <small>
              Built using Flutter ,dart ,sql, AWS and socket.io.
              </small>
              <p>
                The app is use to lottery.
              </p>
            </Project>
            <Project
              title="Checkout page"
              img={sc8}
              tech=""
              link=""
              repo="/"
            >
              <small>
              Built using Nextjs ,tailwindCss ,springBoot...
              </small>
              <p>
                This checkout page help the user to integrate payment.
              </p>
            </Project>
            <Project
              title="Covid-19 Tracker."
              img={sc2}
              tech="js css react"
              link="https://techture-covied-19.firebaseapp.com/"
              repo="/"
            >
              <small>
                Built using firebase, CSS , React.js and React Router.
              </small>
              <p>
                This is a full-stack website that I made which lets the users to get information about covid.
              </p>
            </Project>
            <Project
              title="Illegal activity reporting app."
              img={sc4}
              tech="js css react"
              link="https://play.google.com/store/apps/details?id=com.mashatechnologies.masha_alpha"
              repo="/"
            >
              <small>
                Built using firebase, Flutter , Getx and more...
              </small>
              <p>
                This is a full-stack website that I made which lets the users can report Illegal activity related to there daily usage.
              </p>
            </Project>
            <Project
              title="DashBoard"
              img={sc3}
              tech="js css react"
              link="/"
              repo="/"
            >
              <small>
                Built using springBoot, tailwindCss , NextJs and more...
              </small>
              <p>
                This is a full-stack website that I made which lets the users control there data.
              </p>
            </Project>
            <Project
              title="Website"
              img={sc5}
              tech="js css react"
              link="https://arifpay.net/"
              repo="/"
            >
              <small>
                {/* Built using wordPress... */}
              </small>
              <p>
                This is a  website  I made for Arifpay.
              </p>
            </Project>
           
          </div>
           
          </div>
        </div>
      </section>
    );
  };

  export default Projects;